import { CircleClose as CircleClose_kojaro } from './CircleClose.kojaro';
import { CircleClose as CircleClose_zoomg } from './CircleClose.zoomg';
import { CircleClose as CircleClose_zoomit } from './CircleClose.zoomit';
import { CircleClose as CircleClose_phosphor } from './CircleClose.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return CircleClose_kojaro;

    case 'zoomg':
      return CircleClose_zoomg;

    case 'phosphor':
      return CircleClose_phosphor;


    default:
      return CircleClose_zoomit;
  }
};

export const CircleClose = IconRenderer();
